import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PendingListSkeletonComponent } from './pending-list-skeleton.component';
import { CardSkeletonModule } from '../card-skeleton/card-skeleton.module';
import { IonicModule } from '@ionic/angular';



@NgModule({
  declarations: [PendingListSkeletonComponent],
  exports: [PendingListSkeletonComponent],
  imports: [
    CommonModule,
    IonicModule,
    CardSkeletonModule
  ]
})
export class PendingListSkeletonModule { }
